import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FetchProductTypeCategoriesService } from '../../../services/fetch-product-type-categories.service';
import { MandatoryFieldsService } from '../../../services/mandatory-fields.service';
import { BaseField } from '../../baseField';
import { FetchCollectionCustomersService } from 'src/app/shared/services/fetch-collection-customers.service';

@Component({
  selector: 'app-collection-customers',
  templateUrl: './collection-customers.component.html',
  styleUrls: ['./collection-customers.component.scss'],
})
export class CollectionCustomersComponent
  extends BaseField
  implements OnInit, AfterViewInit
{
  arrayOfOptions: any[] = [];
  mandatoryCategories = ['Customer'];
  mandatory: boolean = false;
  @Input() defaultValue: any;
  searchKey: string = '';

  constructor(
    private fetchCollectionCustomers: FetchCollectionCustomersService,
    private mandatoryFieldsService: MandatoryFieldsService,
    private translate: TranslateService
  ) {
    super();
  }

  async ngOnInit() {
    this.searchKey = 'customerBusinessName';

    this.mandatory =
      this.mandatoryFieldsService.isMandatory(
        this.mandatoryCategories,
        this.fieldObject.fieldName
      ) || false;
    try {
      this.fetchCollectionCustomers.setParams({});
    } catch (err) {
      console.log(err);
    }
  }

  async ngAfterViewInit() {
    const result = await this.fetchCollectionCustomers.make();
    this.translate.onLangChange.subscribe((lang) => {
      console.log(lang.lang);
      if (lang.lang === 'ar') {
        this.searchKey = 'nameAr';
      } else {
        this.searchKey = 'name';
      }
    });
    this.arrayOfOptions = result.data.result;

  }

  selectedValue(event: number) {
    this.formControlRef.setValue(event);
  }

  translateFieldName(fieldObject: any) {
    if (localStorage.getItem('language') === 'ar') {
      return fieldObject.fieldNameAr;
    } else {
      return fieldObject.fieldName;
    }
  }
}
